import { render, staticRenderFns } from "./home.vue?vue&type=template&id=532b5778&"
import script from "./script/home.js?vue&type=script&lang=js&"
export * from "./script/home.js?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=532b5778&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports